import { SET_BOUNDS_SETTINGS } from './types'

export function setBoundsSettings(settings) {
  return {
    type: SET_BOUNDS_SETTINGS,
    payload: settings,
  }
}